import React from "react";

const PopupModal = (props) => {
  return (
    <div className="row container-fluid mb-5">
      <div className="col-md-12">
        <div
          className="modal fade"
          id={props.modalId}
          // id="maleplanmodal"
          data-bs-keyboard="false"
          aria-labelledby="exampleModalLabel"
          aria-hidden="true"
        >
          <div className="modal-dialog">
            <div className="modal-content px-4">
              <div className="modal-header px-4 border-0">
                <h5 className="modal-title">{props.title}</h5>
                <button
                  type="button"
                  className="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                ></button>
              </div>
              <div className="modal-body pt-4 pb-2 px-4">
                {props.component}
              </div>

              <div className="modal-footer px-3 border-0 mb-3">
                <button
                  type="button"
                  // onClick={() =>   setMembers(memberAdd)}
                  data-bs-dismiss="modal"
                  onClick={() => {
                    document.getElementById("btn-close").click();
                    if (props.posDataFn) {
                        props.onClickEvent();
                    }
                  }}
                  className="description_btnsave w-100 "
                  style={{
                    backgroundColor: "#1F7E78",
                    borderColor: "#1f7e78",
                  }}
                >
                  {"Assign"}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PopupModal;
